import { Component, OnInit } from '@angular/core';
import { ApiConstants } from 'src/app/core/constants/api-path.constants';
import { ApiService } from 'src/app/core/services/api.service';
import { NotificationService } from 'src/app/core/services/notification.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AppConstants } from 'src/app/core/constants/appconstants';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-metro',
  templateUrl: './metro.component.html',
  styleUrls: ['./metro.component.scss']
})
export class MetroComponent implements OnInit {

  metroForm: FormGroup;
  tableData: any = [];
  sites: any;
  title: any = '';
  editFlag: boolean = false;
  setupFlag: boolean = false;
  tableFlag: boolean = false;
  editData: any;
  _mColumns: any

  constructor(private apiService: ApiService,
    private notifyService: NotificationService,
    private ngxLoader: NgxUiLoaderService,
    private fb: FormBuilder
  ) {
    this.metroForm = this.fb.group({
      site: ['', Validators.required],
      stationName: ['', Validators.required],
      metroRouteName: ['', Validators.required],
      latitude: ['', Validators.required],
      longitude: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.getAllMetroSetups();
  }

  getAllMetroSetups() {
    this.ngxLoader.start();
    this.apiService.doGetRequestWithResponse(ApiConstants.getAllMetroSetups, (success) => {
      this.ngxLoader.stop();
      this.tableData = success.status === 200 ? success.body.map(data => ({ ...data, siteName: data.site.siteName })) : [];
      this.tableFlag = true;
      this.setupFlag = false;
      if (success.status === 200) {
        this._mColumns = [
          { label: 'Site', key: 'siteName' },
          { label: 'Station Name', key: 'stationName' },
          { label: 'Metro Route Name', key: 'metroRouteName' },
          { label: 'Longitude', key: 'longitude' },
          { label: 'Latitude', key: 'latitude' },
          { label: 'Status', key: 'status' }
        ];
      } else {
        this.notifyService.showError("No Data Found", null);
      }
    }, (error) => {
      this.ngxLoader.stop();
    });
  }

  addNewMetroSetup() {
    this.getSites();
    this.title = 'Add';
    this.editFlag = false;
    this.setupFlag = true;
    this.tableFlag = false;
    this.metroForm.get('site')?.setValue('');
    this.metroForm.get('stationName')?.setValue('');
    this.metroForm.get('metroRouteName')?.setValue('');
    this.metroForm.get('longitude')?.setValue('');
    this.metroForm.get('latitude')?.setValue('');
  }

  getSites() {
    this.apiService.doGetRequestWithResponse(ApiConstants.getActiveSitesbyUser, (success) => {
      if (success.status === 200) {
        this.sites = success.body;
        if (this.editFlag) {
          this.metroForm.get('site').setValue(this.editData.site.siteId);
        } else if (this.sites && this.sites.length > 0) {
          this.metroForm.get('site').setValue(this.sites[0].siteId);
        }
      } else {
        this.notifyService.showInfo("No sites found", null);
      }
    }, (error) => {
      console.log(error)
      this.notifyService.showError(error.message, null);
    });
  }

  onEditIconClicked(data) {
    this.title = 'Edit';
    this.editFlag = true;
    this.getSites();
    this.tableFlag = false;
    this.setupFlag = true;
    this.editData = this.tableData[data.index];
    this.metroForm.get('site').setValue(this.editData.siteName);
    this.metroForm.get('stationName').setValue(this.editData.stationName);
    this.metroForm.get('metroRouteName').setValue(this.editData.metroRouteName);
    this.metroForm.get('longitude').setValue(this.editData.longitude);
    this.metroForm.get('latitude').setValue(this.editData.latitude);
  }

  onBack() {
    this.setupFlag = this.setupFlag == true ? false : true;
    this.tableFlag = this.tableFlag == true ? false : true;
  }

  onSubmit() {
    if (!this.editFlag) {
      this.addMetroSetup();
    } else {
      this.updateMetroSetup();
    }
  }

  addMetroSetup() {
    this.ngxLoader.start();
    let Payload = {
      "site": {
        "siteId": this.metroForm.get('site')?.value,
        "siteName": this.sites.find((site) => site.siteId == this.metroForm.get('site')?.value).siteName,
        "status": this.sites.find((site) => site.siteId == this.metroForm.get('site')?.value).status
      },
      "stationName": this.metroForm.get('stationName')?.value,
      "metroRouteName": this.metroForm.get('metroRouteName')?.value,
      "longitude": this.metroForm.get('longitude')?.value,
      "latitude": this.metroForm.get('latitude')?.value,
      "status": "Active"
    }
    this.apiService.doPostRequestWithResponse(ApiConstants.addMetroSetup, Payload, (success) => {
      if (success.status === 200) {
        const isExisting = success.body.message.includes("Setup Already Exists For");
        this.notifyService[isExisting ? 'showWarning' : 'showSuccess'](success.body.message, null);
        if (!isExisting) this.getAllMetroSetups();
      } else {
        this.notifyService.showInfo("Failed to add setup", null);
      }
    }, (error) => { });

  }

  updateMetroSetup() {
    this.ngxLoader.start();
    let Payload = {
      "id": this.editData.id,
      "site": {
        "siteId": this.metroForm.get('site')?.value,
        "siteName": this.sites.find((site) => site.siteId == this.metroForm.get('site')?.value).siteName,
        "status": "Active"
      },
      "stationName": this.metroForm.get('stationName')?.value,
      "metroRouteName": this.metroForm.get('metroRouteName')?.value,
      "longitude": this.metroForm.get('longitude')?.value,
      "latitude": this.metroForm.get('latitude')?.value,
      "status": "Active"
    }
    this.apiService.doPostRequestWithResponse(ApiConstants.editMetroSetup, Payload, (success) => {
      if (success.status === 200) {
        const isExisting = success.body.message.includes("Setup Already Exists");
        this.notifyService[isExisting ? 'showWarning' : 'showSuccess'](success.body.message, null);
        if (!isExisting) this.getAllMetroSetups();
      } else {
        this.notifyService.showInfo("Failed to update setup", null);
      }
    }, (error) => { });
  }

  onStatusChanged(data) {
    let msg = "WARNING : Are you sure want to Disable this setup ?";
    let msgKey = AppConstants.DEACTIVATE_MSG;
    if (data.option.status == AppConstants.DEACTIVE_STATUS) {
      msg = "WARNING : Are you sure want to Enable this setup ?";
      msgKey = AppConstants.ACTIVATE_MSG;
    }
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: 'btn btn-success',
        cancelButton: 'btn btn-danger ms-2'
      },
      buttonsStyling: false
    });
    swalWithBootstrapButtons.fire({
      title: msg,
      text: msgKey,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes',
      cancelButtonText: 'No',
      confirmButtonColor: '#34c38f',
      cancelButtonColor: '#f46a6a',
    }).then(result => {
      if (result.value) {
        swalWithBootstrapButtons.fire('Done', msgKey, 'success');
        this.onStatusToggled(data);
      } else {
        swalWithBootstrapButtons.fire('Cancelled', 'Deactivated', 'error');
        this.tableFlag = true;
        this.setupFlag = false;
        this.getAllMetroSetups();
      }
    });
  }

  onStatusToggled(data) {
    let reqData: any = {};
    reqData.id = data.option.id;
    reqData.status =
      data.option.status === AppConstants.ACTIVE_STATUS
        ? AppConstants.DEACTIVE_STATUS
        : AppConstants.ACTIVE_STATUS;
    this.ngxLoader.start();
    data.option.status = reqData.status;
    this.apiService.doPostRequestWithResponse(ApiConstants.editMetroSetup, data.option, success => {
      this.ngxLoader.stop();
      if (success.status == 200) {
        this.notifyService.showSuccess("Status Updated Successfully", null);
        this.getAllMetroSetups();
      } else {
        this.notifyService.showError("Failed to Edit Status", null);
      }
    }, (error) => {
      this.ngxLoader.stop();
    });
  }

  discard_special_char_And_String(event) {
    var k;
    k = event.charCode;
    return ((k > 64 && k < 91) || (k > 96 && k < 123) || (k >= 48 && k <= 57) || (k === 32));
  }

  ontypeLatandLong(event) {
    let k = event.charCode;
    return (k >= 48 && k <= 57 || k == 45 || k == 46);
  }
}

